<script lang="ts">
  import {
    Row,
    Column,
    Button,
    Dropdown,
    Checkbox,
    Slider,
    FormGroup,
    RadioButtonGroup,
    RadioButton,
    TextInput,
    TooltipIcon,
  } from 'carbon-components-svelte'
  import GameChat from './GameChat.svelte'
  import GamesStore from '../stores/games'
  import {
    isCheckBoxSetting,
    isDoubleSliderSetting,
    isDropDownSetting,
    isRadioButtonSetting,
    isSliderSetting,
    isTextFieldSetting,
  } from '../dto'
  import type { RunningGame } from '../stores/games'

  export let gameId: number

  const { runningGames } = GamesStore

  const game: RunningGame = $runningGames.find((game) => game.gameId === gameId)
  const settings = game.settings.sort((s1, s2) => s1.settingId - s2.settingId)

  const startGame = () => {
    GamesStore.startGame(game, settings)
  }
  if (!settings || !settings.length) {
    startGame()
  }
</script>

{#if game.stage === 'CREATE' && game.settings?.length}
  <div class="m2">
    <Row>
      <Column lg={16}>
        <h1 style="margin-bottom: 1.5rem">{game.title}</h1>
      </Column>
    </Row>
    <Row>
      <Column lg={16}>
        <h2 style="margin-bottom: 1.5rem">Settings</h2>
      </Column>
    </Row>
    {#each game.settings as setting}
      <Row style="margin-top: 1.5rem; margin-bottom: 1.5rem">
        <Column lg={16}>
          <TooltipIcon
              style="background-color: transparent !important;"
              tooltipText={setting.toolTip}
              direction="right"
            >
            {#if isCheckBoxSetting(setting)}
              <fieldset>
                <Checkbox
                    labelText={setting.description}
                    id="setting-{setting.settingId}"
                    bind:checked={setting.currentValue}
                  />
              </fieldset>
            {:else if isDropDownSetting(setting)}
              <Dropdown
                id="setting-{setting.settingId}"
                items={setting.strings.map((text, idx) => ({ text, id: `${idx}`}))}
                label="{setting.description}"
                titleText="{setting.description}"

                />
            {:else if isRadioButtonSetting(setting)}
              <FormGroup legendText={setting.description}>
                <RadioButtonGroup selected={setting.currentValue} id="setting-{setting.settingId}" >
                  {#each setting.strings as buttonString, idx}
                    <RadioButton
                      id="radio-{idx}"
                      labelText={buttonString}
                      bind:value={buttonString} />
                  {/each}
                </RadioButtonGroup>
              </FormGroup>
            {:else if isSliderSetting(setting)}
              <Slider
                id="setting-{setting.settingId}"
                labelText={setting.description}
                max={setting.max}
                min={setting.min}
                step={setting.stepWidth}
                bind:value={setting.currentValue}
                />
            {:else if isDoubleSliderSetting(setting)}
              <div>DoubleSlider not yet implemented</div>
            {:else if isTextFieldSetting(setting)}
              <div>
                <TextInput
                    id="setting-{setting.settingId}"
                    invalidText="A valid value is required"
                    labelText="{setting.description}"
                    bind:value={setting.currentValue}
                  />
              </div>
            {/if}
          </TooltipIcon>
        </Column>
      </Row>
    {/each}
    <Row>
      <Column lg={16}>
        <Button on:click={startGame}>Start</Button>
      </Column>
    </Row>
  </div>
{:else}
  <div class="game-area">
    <h1 style="margin-bottom: 1.5rem">game</h1>
  </div>
  <GameChat {gameId}/>
{/if}

<style>
  .m2 {
    margin: 2rem;
  }
  .game-area {
    flex-grow: 1;
  }
</style>
